/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Lovec_RealitInputs */

const cs_enum_lovec_realit = /** @type {(inputs: Enum_Lovec_RealitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lovec-Realit`)
};

const en_enum_lovec_realit = /** @type {(inputs: Enum_Lovec_RealitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lovec-Realit`)
};

/**
* | output |
* | --- |
* | "Lovec-Realit" |
*
* @param {Enum_Lovec_RealitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lovec_realit = /** @type {((inputs?: Enum_Lovec_RealitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Lovec_RealitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lovec_realit(inputs)
	return cs_enum_lovec_realit(inputs)
});